export const AutoIncrement = (value: number, padType: string = '0') => {
    let prefix = 'FAT';
    return prefix + String(value).padStart(4, padType);
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/auto-increment.ts